import React, { useEffect } from "react";

import "./pdfPreviewPopUp.css";
import XIcon from "../assets/icons/xIcon";
import { useDashboardContext } from "../context/dashboardContext";
import { useAppContext } from "../context/appContext";

interface PDFPreviewPopUpProps {
    url: string;
    open: boolean;
    setOpen: (v: boolean) => void;
}

export default function PDFPreviewPopUp(props: PDFPreviewPopUpProps) {

    const {assetController} = useAppContext();

    const [isPDF, setIsPDF] = React.useState<boolean>(false);

    useEffect(() => {
        checkPDF();
    })

    async function checkPDF() {
        try {
            const response = await fetch(props.url + "/info"); // Make a HEAD request to avoid downloading the file
            const data = await response.json();
            if(data.mimeType === "application/pdf") {
                setIsPDF(true);
            } else {
                setIsPDF(false);
            }
        } catch (error) {
            console.error("Error checking URL content type:", error);
            setIsPDF(false); // Return false on error
        }
    }

    return <div className={ "pdf-preview-pop-up" + (props.open ? " open" : "") } onClick={(event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget) {
            props.setOpen(false);
        }

    }}>
        <div className="close" onClick={() => {
            props.setOpen(false);
        }}>
            <XIcon/>
        </div>
        {isPDF ? <iframe src={props.url} title="PDF Preview" className="pdf-iframe"/> : <img src={props.url} alt="Preview" className="image"/>}
    </div>;

}